import React, {Component} from "react";
import {Field, Fields, reduxForm} from 'redux-form';
import ValidatedInputField from "../common/form/ValidatedInputField";
import RteEditor from "../common/form/RteEditor";
import SubmitButton from "../common/SubmitButton";
import FileUploadComponent from "../common/file/FileUploadComponent";
import DropDownOptions from "../helpers/DropDownOptions";
import {validation} from "./validation";
import ValidatedSelect from "../common/ValidatedReactSelect";
import afterSubmitFail from "../common/form/focusAfterSubmitFail";
import ResetButton from "../common/ResetButton";

class MachineRentalForm extends Component {
    constructor(props) {
        super(props);
    }

    renderClearButton() {
        if (this.props.isUpdate && this.props.initialValues.image) {
            return (
                <button
                    onClick={this.props.onClear}
                    className="btn btn-sm"
                    type="button"
                >
                    Slet billede
                </button>
            )
        }
        return null;
    }

    render() {
        console.log(this.props);
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row">
                    <div className="col-12">
                        <Field
                            type="text"
                            name="name"
                            component={ValidatedInputField}
                            placeholder={"Navn"}
                            className="form-control"
                            label={"Navn"}
                        />
                        <Field
                            type="text"
                            name="description"
                            component={RteEditor}
                            placeholder={"Beskrivelse"}
                            className="form-control"
                            editorName={'machine-rental-description'}
                            label={"Beskrivelse"}
                            isUpdate={this.props.isUpdate}
                        />
                        <div className="row">
                            <label className="col-sm-2 col-form-label">
                                <b>Kategori</b>
                            </label>
                            <div className="col-sm-10">
                                <Field
                                    type="select"
                                    name="categoryId"
                                    component={ValidatedSelect}
                                    options={DropDownOptions.getOptions(this.props.categories, 'id', 'name')}
                                    placeholder={'Kategori'}
                                />
                            </div>
                        </div>
                        <Field
                            className="form-control"
                            name="quantity"
                            component={ValidatedInputField}
                            type='number'
                            label="Antal"
                        />
                        <Field
                            className="form-control"
                            name="price"
                            component={ValidatedInputField}
                            type="number"
                            label="Pris (DKK)"
                        />
                        <div className="form-group row">
                            <div className="col-sm-10 offset-sm-2">
                                <label className="custom-control custom-checkbox">
                                    <Field
                                        name="status"
                                        type="checkbox"
                                        component="input"
                                        className="custom-control-input"
                                    />
                                    <span className="custom-control-indicator"> </span>
                                    <span className="custom-control-description">Aktiv</span>
                                </label>
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>Billede</b>
                            </label>
                            <div className="col-sm-10">
                                <div className="input-group">
                                     <span className="input-group-btn m-r-10">
                                         {this.renderClearButton()}
                                    </span>
                                    <Field
                                        name="image"
                                        type="file"
                                        component={FileUploadComponent}
                                        label="Billede upload"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row">
                            {this.props.initialValues.image ?
                                <img
                                    alt="preview"
                                    className="rounded mx-auto d-block img-thumbnail"
                                    src={`${this.props.initialValues.image.filePath}`}
                                /> : null
                            }
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-12">
                                <div className="offset-sm-2">
                                    <SubmitButton isUpdate={this.props.isUpdate}/>
                                    <ResetButton onClick={this.props.handleReset}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default MachineRentalForm = reduxForm({
    form: 'machine-rent',
    validate: validation,
    onSubmitFail: afterSubmitFail
})(MachineRentalForm);


// WEBPACK FOOTER //
// ./web/src/components/machine-rental/MachineRentalForm.jsx